import BaseModel from './BaseModel'

export default class PrintRequest extends BaseModel {
  // ... PrintRequest-specific methods or overrides ...
}
